export default __webpack_public_path__ + "static/media/nalayak.baae3c07.jpeg";